import type { AxiosInstance } from 'axios';

interface UploadRequest {
  contentType: 'image/jpeg' | 'image/png' | 'image/gif' | 'image/webp' | 'image/heic' | 'image/heif';
  filename: string;
  type: 'picture' | 'banner';
}

interface UploadResponse {
  uploadUrl: string;
  imageUrl: string;
  expiresIn: number;
}

export const ContentService = (api: AxiosInstance) => {
  return {
    getUploadUrl: async (request: UploadRequest) => {
      const response = await api.post<UploadResponse>('/content/images/upload', request);
      return response.data;
    },

    uploadFile: async (url: string, file: Blob | File) => {
      await fetch(url, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type
        }
      });
    }
  };
}; 